import React from 'react';
import { ShieldCheck, Thermometer } from 'lucide-react';

/**
 * WeatherTrustBlock — small static "How we ship safely" trust card.
 *
 * Mounted on the product detail page (below variations/animals) and the
 * first checkout step. Pure presentational; tokenized so it follows both
 * light and dark themes. Inline var() styles keep it self-contained.
 */
const styles = {
  card: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'var(--ff-space-md, 12px)',
    border: '1px solid var(--ff-border-primary, #dee2e6)',
    background: 'var(--ff-surface-secondary, #f8f9fa)',
    borderRadius: 'var(--ff-radius-md, 8px)',
    padding: 'var(--ff-space-lg, 16px)',
    maxWidth: '640px',
    margin: 'var(--ff-space-2xl, 32px) auto',
  },
  icons: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--ff-space-xs, 4px)',
    // R3 (2026-10-07): not the accent — the link blue, which reads (AA)
    color: 'var(--ff-link)',
    flexShrink: 0,
    marginTop: '2px',
  },
  heading: {
    margin: 0,
    marginBottom: 'var(--ff-space-xs, 4px)',
    fontSize: 'var(--ff-font-size-md, 1rem)',
    fontWeight: 700,
    color: 'var(--ff-text-primary, #212529)',
  },
  copy: {
    margin: 0,
    fontSize: 'var(--ff-font-size-sm, 0.875rem)',
    lineHeight: 1.5,
    color: 'var(--ff-text-secondary, #6c757d)',
  },
};

function WeatherTrustBlock() {
  return (
    <div className="weather-trust-block" style={styles.card}>
      <div style={styles.icons} aria-hidden="true">
        <ShieldCheck size={22} />
        <Thermometer size={22} />
      </div>
      <div>
        <h4 style={styles.heading}>How we ship safely</h4>
        <p style={styles.copy}>
          Every shipment is weather-checked — departure, overnight transit,
          and arrival — with hub pickup fallback when temperatures are
          unsafe. Live arrival guaranteed.
        </p>
      </div>
    </div>
  );
}

export default WeatherTrustBlock;
